import { render, staticRenderFns } from "./matrix-select.vue?vue&type=template&id=23664f56&scoped=true"
import script from "./matrix-select.vue?vue&type=script&lang=js"
export * from "./matrix-select.vue?vue&type=script&lang=js"
import style0 from "./matrix-select.vue?vue&type=style&index=0&id=23664f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23664f56",
  null
  
)

export default component.exports